import { WAREHOUSE_PATHS } from './paths';
import { isPickingStage } from './status';
import type { GoodsIssueStatus } from './types';

/**
 * Shipments is another feature: link to it by URL only (TRD § Frontend —
 * no imports from src/pages/shipments). `detail` opens its panel, `q`
 * narrows the list to the waybill.
 */
export const shipmentsUrl = (f: {
  shipmentID: string | null;
  waybill: string | null;
}): string =>
  `/shipments?${new URLSearchParams({
    ...(f.waybill ? { q: f.waybill } : {}),
    ...(f.shipmentID ? { detail: f.shipmentID } : {}),
  }).toString()}`;

/** Picking screen while RESERVED/PICKED (and cancelled), Shipping after. */
export const goodsIssueUrl = (gi: {
  id: string;
  status: GoodsIssueStatus;
}): string =>
  `${
    isPickingStage(gi.status) || gi.status === 'CANCELLED'
      ? WAREHOUSE_PATHS.picking
      : WAREHOUSE_PATHS.shipping
  }/${gi.id}`;
